import React from "react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
const verbs = ["Review", "Organize", "Document", "Question", "Reflect"];
export function FinalCta() {
  return <section className="bg-navy px-4 py-16 text-center sm:py-20" data-id="element-136" data-mp="1nprk0cposfuv">
      <div className="mx-auto max-w-3xl" data-id="element-137" data-mp="1nn5a46fbpo9h">
        <p className="text-sm font-extrabold uppercase tracking-[0.16em] text-teal-light" data-id="element-138" data-mp="1sn16bjhs4beh">Ready to stop starting from a blank page?</p>
        <h2 className="mt-3 font-serif text-[2rem] font-extrabold leading-tight text-white sm:text-5xl" data-id="element-139" data-mp="1en086bswfi2p">
          Start organizing my rhinoplasty case reviews <span className="italic text-teal-light" data-id="element-140" data-mp="14qx4h1iefbdn">with a system.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-141" data-mp="19oyllgw9l0mh">
          Instead of scattered notes, disconnected resources and a different process every time… I can have a structured planning framework that helps me:
        </p>
        <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-142" data-mp="342pw0imf3oiz">
          {verbs.map(v => <li key={v} className="rounded-full bg-teal-light px-4 py-2 text-[15px] font-bold text-navy" data-id="element-143" data-mp="27jye0nz24mx">
              ✓ {v}
            </li>)}
        </ul>

        <p className="mt-8 font-serif text-5xl font-black text-white" data-id="element-144" data-mp="b1oo2grdda0v">Only $27</p>
        <CtaButton label="I want the Rhinoplasty Master Planner™" note="One-time payment · Instant Digital Access · Lifetime Access · 7-Day Guarantee" noteTone="light" className="mt-6" data-id="element-145" data-mp="6zbhxr8pna3k" />
        <Countdown tone="light" data-id="element-146" data-mp="3ahvayvz7qjzf" />
      </div>
    </section>;
}